import { createFileRoute } from '@tanstack/react-router';
import { useBreadcrumbLabel } from '../../../../components/BreadcrumbLabelsContext.js';
import { ListErrorState } from '../../../../components/ListErrorState.js';
import { assertUuidRouteParams } from '../../../../lib/assert-uuid-route-params.js';
import { LeafLinkCompanyDetails } from '../../../../modules/leaflink-companies/leaflink-company-details.js';
import { useLeafLinkCompanyQuery } from '../../../../modules/leaflink-companies/use-leaflink-company-query.js';

export const Route = createFileRoute('/integrations/leaflink/$leafLinkIntegrationId/')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: LeafLinkCompanyDetailsPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function LeafLinkCompanyDetailsPage() {
  const { leafLinkIntegrationId } = Route.useParams();
  const { data, loading, error, refetch } = useLeafLinkCompanyQuery(leafLinkIntegrationId);

  useBreadcrumbLabel(leafLinkIntegrationId, data?.leafLinkCompany?.name);

  if (error) {
    return (
      <ListErrorState
        title="Could not load this LeafLink company"
        message={error.message}
        onRetry={() => void refetch()}
      />
    );
  }

  return <LeafLinkCompanyDetails company={data?.leafLinkCompany ?? null} loading={loading} />;
}
